'use strict';

namespace Core {

    class SelectedFlightSummary {

        flight: any;
        hideCaption: boolean = false;
        changeFlightEnabled: string | boolean;
        changeFlightInterstitial: boolean;
        tripId: string;

        constructor(private broker: Broker,
                    private flightSearch,
                    private $scope: ng.IScope,
                    private resourceService: Core.ResourceService,
                    private basketService,
                    private occupancyService) {
            this.changeFlightEnabled = this.changeFlightEnabled === 'true';
        }

        init (container : ng.IAugmentedJQuery) {
        }

        public showDetails(e) {
            const passengers = this.occupancyService.getTotalPeopleCounts();
            e.preventDefault();
            this.broker.publish('showModalFlightDetails', {
                flight: this.flight.Details.Itinerary,
                passengers
            });
        }

        private changeFlight(): void {
            this.flightSearch.resetPageIndex();
            this.basketService.changeJourneyUrl(10, this.tripId);

            if (this.changeFlightInterstitial) {
                this.$scope.$emit('block', {
                    title: this.resourceService.get('SEARCHINGFLIGHTS'),
                    subtitle: this.resourceService.get('THISMAYTAKE'),
                    loadingScreenStyle: 'default-searchUnitCtrl'
                });
            }
        }

    }

    angular
        .module('core')
        .directive('selectedFlightSummary', (): ng.IDirective => {

        return {
            scope: {},
            controller: SelectedFlightSummary,
            controllerAs: 'sfs',
            replace: true,
            bindToController: {
                tripId: '=?',
                flight: '=',
                changeFlightEnabled: '@',
                changeFlightInterstitial: '<',
                hideCaption: '@'
            },
            templateUrl: (element, attr) => {
                if(attr.templateVersion){
                    return 'partials/booking/template?name=SelectedFlightSummary&version='
                    + attr.templateVersion;
                }
                return 'partials/home/directivetemplate?type=SelectedFlightSummary';
            },
            link: function (scope : ng.IScope, el : ng.IAugmentedJQuery, attr, controller : SelectedFlightSummary) {
                controller.init(el);
            }

        };

    });

}
